import { render, staticRenderFns } from "./MarketAdminHome.vue?vue&type=template&id=15341979&scoped=true&"
import script from "./MarketAdminHome.vue?vue&type=script&lang=js&"
export * from "./MarketAdminHome.vue?vue&type=script&lang=js&"
import style0 from "./MarketAdminHome.vue?vue&type=style&index=0&id=15341979&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15341979",
  null
  
)

export default component.exports